import { FC, ReactNode } from "react";

import Tab from "@mui/material/Tab";
import Tabs, { TabsProps } from "@mui/material/Tabs";
import { MuiBox } from "../box/MuiBox";
import { MuiTypography } from "../typography/MuiTypography";
import { MuiTabsWrapper } from "./MuiTabs.style";

export interface ITabs {
  id: string;
  label: string;
  showBadgeIcon?: ReactNode;
  count?: string | number;
  className?: string;
   content?: ReactNode | (() => ReactNode);
}

export type MuiTabsProps = TabsProps & {
  tabs: ITabs[];
  tabsTestIds?: string[];
  classNames?: string[];
  indicatorColor?: string;
  tabStyle?: string;
};

export const resolveContent = (content?: ReactNode | (() => ReactNode)): ReactNode => {
  return typeof content === "function" ? content() : content;
}

export const MuiTabs: FC<MuiTabsProps> = (props) => {
  const {
    tabs,
    orientation = "horizontal",
    variant = "scrollable",
    scrollButtons = false,
    children,
    tabsTestIds,
    classNames = [],
    indicatorColor,
    tabStyle = "",
    ...rest
  } = props;

  return (
    <MuiTabsWrapper>
      <MuiBox className={`${indicatorColor} ${tabStyle} Mui-tabs`}>
        <Tabs
          orientation={orientation}
          variant={variant}
          scrollButtons={scrollButtons}
          {...rest}
        >
          {tabs.map((tab, index) => {
            return (
              <Tab
                tabIndex={0}
                data-testid={
                  tabsTestIds ? tabsTestIds[index] : `Mui-tab-test-${tab.label}`
                }
                className={classNames[index] ?? ""}
                label={
                  tab.showBadgeIcon || tab.count ? (
                    <MuiBox className="d-flex">
                      {tab.label}
                      {tab.showBadgeIcon && (
                        <MuiBox className="notification-icon">
                          {tab.showBadgeIcon}
                        </MuiBox>
                      )}
                      {tab.count && (
                        <MuiTypography
                          variant="h3SemiBold"
                          className="selected-count"
                        >
                          {tab.count}
                        </MuiTypography>
                      )}
                    </MuiBox>
                  ) : (
                    tab.label
                  )
                }
                key={`${tab.label}-${index}`}
                aria-label={tab.label}
                role="tab"
                id={tab.id}
              />
            );
          })}
        </Tabs>
        {children}
      </MuiBox>
    </MuiTabsWrapper>
  );
};
